import { CryptolectApiError } from "@cryptolect/api-client";

export function getErrorMessage(error: unknown): string {
  if (error instanceof CryptolectApiError) {
    switch (error.code) {
      case "invalid_token":
        return "Please sign in again";
      case "cipher_not_granted":
        return "You don't have permission to access this cipher";
      case "cipher_not_found":
        return "Cipher not found";
      case "rate_limited":
        return "Too many requests. Please wait a moment.";
      case "decode_failed":
        return "Decode failed — input does not match this cipher";
      case "upstream_error":
        return "Server error. Please try again later.";
      case "quota_exceeded":
        return "You've hit your plan's quota for this operation";
      case "invalid_input":
        return error.message;
      default:
        return error.message;
    }
  }
  if (error instanceof Error) return error.message;
  return "An unexpected error occurred";
}

export function isAuthError(error: unknown): boolean {
  return error instanceof CryptolectApiError && error.code === "invalid_token";
}

export function isForbiddenError(error: unknown): boolean {
  return (
    error instanceof CryptolectApiError && error.code === "cipher_not_granted"
  );
}

export function isRateLimitError(error: unknown): boolean {
  return error instanceof CryptolectApiError && error.code === "rate_limited";
}

export function isNotFoundError(error: unknown): boolean {
  return error instanceof CryptolectApiError && error.code === "cipher_not_found";
}
